// extracted by mini-css-extract-plugin
export default {"container":"TopCompaniesHiring_container__9MaWw","btnContainer":"TopCompaniesHiring_btnContainer__3bXCn"};